export const SERVICES_IDS = {
  HOSTING: 1,
  GATOR_PROTECT: 2,
  OPEN_CLAW: 3,
  EMAIL: 4,
};
